var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultUserThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f6f6fb;stroke:#d5d7e2;opacity:0.593;}.b{fill:#d5d5e0;}.c{stroke:none;}.d{fill:none;}.e{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 178,
    height: 178,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68 -115)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.381 3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.381 118)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 160,
    height: 160,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 159,
    rx: 4.5
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M49.785,54.436c15.713,0,28.449-12.184,28.449-27.218S65.5,0,49.785,0,21.337,12.184,21.337,27.218,34.072,54.436,49.785,54.436ZM69.7,61.24H65.988a40.282,40.282,0,0,1-32.4,0H29.871C13.38,61.24,0,74.041,0,89.819v8.846a10.448,10.448,0,0,0,10.668,10.207H88.9A10.448,10.448,0,0,0,99.571,98.664V89.819C99.571,74.041,86.191,61.24,69.7,61.24Z",
    transform: "translate(107.215 146.564)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserThumbnail);
export default __webpack_public_path__ + "static/media/default-user-thumbnail.326461d604c5203e3be2808ec3cb1bbe.svg";
export { ForwardRef as ReactComponent };